import { pxToRem } from '../../../../utils';
export var toolbarMenuItemIconStyles = {
  root: function root(_ref) {
    var p = _ref.props;
    return Object.assign({}, p.hasContent && {
      marginRight: pxToRem(10),
      marginTop: pxToRem(3),
      display: 'flex',
      alignSelf: 'start'
    });
  }
};